<div class="day-switcher" [ngClass]="{'no-prices': no_prices}" tabindex="0" >
	<div class="day-switcher__arrow arrow-back" (click)="INDRA_handleMoveBack()">
		<app-svg svg="icons.svg#general--arrow--left" id="back" aria-hidden="true" [alt]="'Arrow left icon'"></app-svg>
	</div>
	<div class="day-switcher__content" #daySwitcherContent>
		<app-loading-shadow *ngIf="isLoading" [height]="'9rem'"></app-loading-shadow>
		<div *ngIf="!isLoading" class="day-switcher__list" aria-label="List with lowest price in the past or upcoming days">
			<button (click)="INDRA_selectEntry(index, 2)" [attr.aria-label]="INDRA_printEntryAriaLabel(entry, index)"
				class="day-switcher__entry" [ngClass]="INDRA_getEntryClasses(index)"
				*ngFor="let entry of daysPrice; let index = index" role="button" tabindex="0" [tooltip]="INDRA_printTooltip(entry, index)">
				<div aria-hidden="true" class="day-switcher__entry-price" [ngStyle]="INDRA_getPriceStyle(entry.price)"  *ngIf="hasPrices && daySwitcherEnabled"></div>
				<div aria-hidden="true" class="day-switcher__entry-day">{{INDRA_printDay(entry.date)}}</div>
				<div aria-hidden="true" class="day-switcher__entry-weekday">{{ ('dates.text.' + INDRA_printWeekday(entry.date) | ibeadmin | async).substring(0, 2) }}</div>
			</button>
		</div>
	</div>
	<div class="day-switcher__arrow arrow-forward" (click)="INDRA_handleMoveForward()">
		<app-svg svg="icons.svg#general--arrow--right" id="forward" aria-hidden="true" [alt]="'Arrow right icon'"></app-svg>
	</div>
</div>
